import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  { id: "quinta", label: "A Quinta" },
  { id: "acomodacoes", label: "Acomodações" },
  { id: "piscina", label: "Piscina Social" },
  { id: "contato", label: "Contato" },
];

export const Nav = () => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const home = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const solid = scrolled || !home;
  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${
        solid ? "bg-[#f4f0e6]/90 backdrop-blur-xl shadow-[0_1px_0_#d9d2c1] py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="nav-logo" aria-label="Quinta dos Pinhais - início">
          <Logo light={!solid} />
        </Link>
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <Link
              key={l.id}
              to={`/#${l.id}`}
              data-testid={`nav-${l.id}-link`}
              className={`group relative text-[13px] uppercase tracking-[0.18em] ${solid ? "text-[#1a382b]" : "text-[#f3efe4]"}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#7ab51d] transition-transform duration-300 group-hover:scale-x-100" />
            </Link>
          ))}
          <Link
            to="/#acomodacoes"
            data-testid="nav-reservar-button"
            className="rounded-full bg-[#7ab51d] px-6 py-3 text-[13px] font-bold uppercase tracking-[0.14em] text-[#14291f] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#8cc92a]"
          >
            Reservar
          </Link>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className={`md:hidden rounded-full p-2 ${solid ? "text-[#1a382b]" : "text-white"}`}
          aria-label="Abrir menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-[#d9d2c1] bg-[#f4f0e6] px-5 pb-6 pt-2">
          {LINKS.map((l) => (
            <Link
              key={l.id}
              to={`/#${l.id}`}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-${l.id}-link`}
              className="block border-b border-[#e3dccb] py-4 text-lg text-[#1a382b]"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
